/* Alfara Estética — motor de revelado y tónicos de fondo (sistema «Glass»).
 *
 * Tres cosas, y nada más:
 *  1. Marca automáticamente qué elementos se revelan y con qué mecánica
 *     (los de Dawn no traen data-g-reveal; las secciones glass-* sí).
 *  2. Un IntersectionObserver les pone .g-in cuando entran en pantalla.
 *  3. Mueve las tres manchas del fondo (.g-orb) con el scroll y, en escritorio,
 *     un poco con el puntero. Sólo transform: nunca repinta.
 *
 * Con prefers-reduced-motion no hace nada: el CSS ya deja todo visible.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    document.documentElement.classList.add('g-sin-motion');
    return;
  }

  /* 1. Etiquetado automático de las secciones nativas de Dawn ------------------ */
  var AUTO = [
    ['.card-wrapper', 'pour', true],
    ['.multicolumn-card', 'pour', true],
    ['.image-with-text__media', 'wipe', false],
    ['.image-with-text__content', 'up', false],
    ['.collapsible-content .accordion', 'up', true],
    ['.title-wrapper-with-link, .title-wrapper, .collapsible-content__heading, .rich-text__blocks', 'blur', false],
    ['.alfara-stats__item', 'pour', true],
    ['.fp-res__card, .fp-conv__cinta-item, .fp-conv__card', 'pour', true],
    ['.fp-res__cab, .fp-conv__cab', 'blur', false]
  ];
  function etiquetar(root) {
    AUTO.forEach(function (regla) {
      var nodos = (root || document).querySelectorAll(regla[0]);
      var i = 0;
      Array.prototype.forEach.call(nodos, function (el) {
        if (el.hasAttribute('data-g-reveal')) return;
        el.setAttribute('data-g-reveal', regla[1]);
        if (regla[2]) {
          // escalonado por posición dentro del mismo padre, tope 6 (después ya no se nota)
          var idx = 0, s = el;
          while ((s = s.previousElementSibling) && idx < 6) idx++;
          el.style.setProperty('--g-delay', (idx * 60) + 'ms');
          el.setAttribute('data-g-delay', '');
        }
        i++;
      });
    });
  }

  /* 2. Palabras: parte un título en spans para el revelado palabra a palabra ---- */
  function partirPalabras(el) {
    if (el.dataset.gSplit) return;
    el.dataset.gSplit = '1';
    var nodos = Array.prototype.slice.call(el.childNodes);
    var n = 0, ultimo = null;
    nodos.forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (tok) {
          if (!tok) return;
          if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(tok)); return; }
          // un signo de puntuación pegado a la palabra anterior (el «.» después de un <em>)
          // se queda con ella: si no, puede saltar solo a la línea siguiente
          if (ultimo && !/^[\wÀ-ÿ¿¡«("']/.test(tok)) { ultimo.appendChild(document.createTextNode(tok)); return; }
          var s = document.createElement('span');
          s.className = 'g-w';
          s.style.setProperty('--g-i', n++);
          s.textContent = tok;
          frag.appendChild(s);
          ultimo = s;
        });
        el.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        // <em> u otros hijos: se envuelven y se revelan como una sola palabra, con su estilo
        var w = document.createElement('span');
        w.className = 'g-w';
        w.style.setProperty('--g-i', n++);
        el.insertBefore(w, node);
        w.appendChild(node);
        ultimo = w;
      }
    });
  }

  /* 3. Observadores ------------------------------------------------------------
     Dos, porque Chrome calcula la intersección DESPUÉS de aplicar clip-path: un
     elemento recortado al 100% (pour, wipe) tiene rectángulo vacío y nunca «entra».
     Para esos se observa al padre (la grilla) y se revelan todos sus hijos recortados
     con su escalonado; para el resto (opacidad/transform) se observa el elemento. */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('g-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  var hijosRecortados = new WeakMap();
  var ioPadre = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      (hijosRecortados.get(e.target) || []).forEach(function (el) { el.classList.add('g-in'); });
      ioPadre.unobserve(e.target);
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -8% 0px' });

  function observar(root) {
    etiquetar(root);
    var els = (root || document).querySelectorAll('[data-g-reveal]:not(.g-obs)');
    Array.prototype.forEach.call(els, function (el) {
      el.classList.add('g-obs');
      var modo = el.getAttribute('data-g-reveal');
      if (modo === 'words') partirPalabras(el);
      // lo que ya está en pantalla al cargar (el hero) se revela sin esperar
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) {
        requestAnimationFrame(function () { el.classList.add('g-in'); });
      } else if (modo === 'pour' || modo === 'wipe') {
        var padre = el.parentElement || el;
        if (!hijosRecortados.has(padre)) { hijosRecortados.set(padre, []); ioPadre.observe(padre); }
        hijosRecortados.get(padre).push(el);
      } else {
        io.observe(el);
      }
    });
  }

  /* 4. Tónicos de fondo ------------------------------------------------------ */
  function fondo() {
    var orbs = document.querySelectorAll('.g-orb');
    if (!orbs.length) return;
    var factores = [0.12, -0.08, 0.05];
    var px = 0, py = 0, ticking = false;
    function pintar() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      Array.prototype.forEach.call(orbs, function (o, i) {
        var f = factores[i % factores.length];
        o.style.setProperty('--g-y', Math.round(y * f) + 'px');
        o.style.setProperty('--g-x', Math.round(px * (i + 1) * 0.6) + 'px');
      });
    }
    function pedir() { if (!ticking) { ticking = true; requestAnimationFrame(pintar); } }
    window.addEventListener('scroll', pedir, { passive: true });
    if (window.matchMedia('(pointer: fine)').matches) {
      window.addEventListener('mousemove', function (ev) {
        px = (ev.clientX / window.innerWidth - 0.5) * 40;
        py = (ev.clientY / window.innerHeight - 0.5) * 40;
        pedir();
      }, { passive: true });
    }
    pintar();
  }

  /* 5. Arranque + editor de temas (Shopify re-renderiza secciones en vivo) ----- */
  function arrancar() { observar(document); fondo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', function (ev) { observar(ev.target); });
})();
